import { useEffect, useState } from "react";

export default function useFilteringSettings(filteringSettings) {
  const [filteringSettingsState, setFilteringSettingsState] = useState({
    messageFilteringEnabled: false,
    filteringPrompt: "",
    // Instagram-only story toggles. Default true (reply) to match the backend schema default.
    enableStoryReply: true,
    enableStoryMention: true,
    errors: {
      filteringPrompt: null,
    },
  });

  useEffect(
    function () {
      setFilteringSettingsState({
        messageFilteringEnabled: filteringSettings.messageFilteringEnabled,
        filteringPrompt: filteringSettings.filteringPrompt,
        enableStoryReply: filteringSettings.enableStoryReply ?? true,
        enableStoryMention: filteringSettings.enableStoryMention ?? true,
        errors: {
          filteringPrompt: null,
        },
      });
    },
    [filteringSettings]
  );

  function updateFilteringPrompt(value) {
    setFilteringSettingsState((prevState) => {
      return {
        ...prevState,
        filteringPrompt: value,
      };
    });
  }

  function toggleFilteringEnable() {
    setFilteringSettingsState((prevState) => {
      return {
        ...prevState,
        messageFilteringEnabled: !prevState.messageFilteringEnabled,
      };
    });
  }

  // Toggle an Instagram story flag (enableStoryReply / enableStoryMention).
  function toggleStorySetting(field) {
    setFilteringSettingsState((prevState) => {
      return {
        ...prevState,
        [field]: !prevState[field],
      };
    });
  }

  return {
    filteringSettingsState,
    updateFilteringPrompt,
    toggleFilteringEnable,
    toggleStorySetting,
  };
}
